export default __webpack_public_path__ + "static/media/icon-answer-user.5b6e1a84.svg";